import React from "react"
import { Instagram, Mail, Phone } from "lucide-react"

export default function About() {
  return (
    <>
      <style jsx global>{`
        @font-face {
          font-family: "Muar-Regular";
          src: url("/fonts/Muar-Regular.ttf") format("truetype");
          font-weight: normal;
          font-style: normal;
        }
        @font-face {
          font-family: "Muar-Stencil";
          src: url("/fonts/Muar-Stencil.ttf") format("truetype");
          font-weight: normal;
          font-style: normal;
        }
      `}</style>
      <div className="container mx-auto px-4 py-16 max-w-5xl">
        <h1 className="text-5xl mb-12 text-center text-purple-800 font-['Muar-Stencil']">
          About the Artist
        </h1>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-16 mb-16">
          <div className="relative">
            <img
              src="/images/About.jpeg"
              alt="Artist portrait"
              className="w-full h-full object-cover rounded-2xl shadow-xl"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-purple-900 to-transparent opacity-30 rounded-2xl"></div>
          </div>
          <div className="flex flex-col justify-center">
            <p className="text-lg leading-relaxed text-gray-300 mb-6 font-['Muar-Regular']">
              <b>Luis Brito</b> was born in Lisbon, in 1986. His artistic name{" "}
              <b>"Breatho"</b> reminds us that everything is breathing - and
              breathing is everything -, including all forms of art and
              expression.
            </p>
            <p className="text-lg leading-relaxed text-gray-300 mb-6 font-['Muar-Regular']">
              He is a published author, with 4 books in Portuguese, having
              worked in advertising and studied classical music as a child.
            </p>
            <p className="text-lg leading-relaxed text-gray-300 mb-6 font-['Muar-Regular']">
              He is a multi-interdisciplinary artist and a committed therapist,
              allways working in the good side of consciousness.
            </p>
            <p className="text-lg leading-relaxed text-gray-300 font-['Muar-Regular']">
              He intends to keep{" "}
              <b>creating and healing, provoking and relaxing</b>, because they
              are the same thing. And if he were to believe in astrology, he
              would claim that, more than an <b>Aquarius</b>, he is the{" "}
              <b>Aquarius</b> - swimming and diving in the age of{" "}
              <b>Aquarius</b>.
            </p>
          </div>
        </div>

        <h2 className="text-3xl mb-8 text-center text-purple-800 font-['Muar-Stencil']">
          Get in Touch
        </h2>
        <div className="flex flex-wrap justify-center gap-6">
          <a
            href="https://www.instagram.com/luis_breatho/?igsh=MWJnZ2gwemhmZTQ4bQ=="
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center bg-gradient-to-r from-pink-500 to-purple-500 hover:from-pink-600 hover:to-purple-600 text-white font-bold py-3 px-6 rounded-full transition duration-300 ease-in-out transform hover:scale-105"
          >
            <Instagram className="w-6 h-6 mr-3" />
            Instagram
          </a>
          <a
            href="mailto:Luismmvbrito@gmail.com"
            className="flex items-center bg-gradient-to-r from-red-500 to-pink-500 hover:from-red-600 hover:to-pink-600 text-white font-bold py-3 px-6 rounded-full transition duration-300 ease-in-out transform hover:scale-105"
          >
            <Mail className="w-6 h-6 mr-3" />
            Email
          </a>
          <a
            href="https://wa.me/+351965220370"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center bg-gradient-to-r from-green-500 to-teal-500 hover:from-green-600 hover:to-teal-600 text-white font-bold py-3 px-6 rounded-full transition duration-300 ease-in-out transform hover:scale-105"
          >
            <Phone className="w-6 h-6 mr-3" />
            WhatsApp
          </a>
        </div>
      </div>
    </>
  )
}
